import { requestIdHeader } from '../constants/requestIdHeader';

/**
 * Vendor-neutral lookup of the API's request id in a set of response
 * headers. Matches the name case-insensitively, since header case depends on
 * the HTTP version and on whoever collected the headers.
 */
export const findRequestId = (
  headers?: Record<string, unknown>,
): string | undefined => {
  const entry = Object.entries(headers ?? {}).find(
    ([name]) => name.toLowerCase() === requestIdHeader,
  );
  const value = entry?.[1];

  return typeof value === 'string' && value ? value : undefined;
};
